import { makeAutoObservable, runInAction } from 'mobx';
import {
  ACCEPT_IMG_TYPE,
  ACCEPT_FILE_TYPE,
} from '@/components/input-file/shared';
import { getExtensionName } from '@/utils/filename';
import knowledgeChoiceStore from '@/components/knowledge-choice/store';

const FILE_MAX_CHECK = 100;
class Store {
  get list_create () {
    return knowledgeChoiceStore.list_create;
  }
  get list_share () {
    return knowledgeChoiceStore.list_share;
  }

  checkedList = [];
  fold_create = false;
  fold_share = false;

  get list_default() {
    if (this.list_create?.length) {
      return this.list_create.filter(item => item.is_default == 1);
    } else {
      return [];
    }
  }

  constructor() {
    makeAutoObservable(this);
  }

  handleCheck = item => {
    if(item){
      this.checkedList = [item];
    }
    else {
      this.checkedList = [];
    }
  };

  toggleFold = (type = 'fold_create') => {
    runInAction(() => {
      this[type] = !this[type];
    });
  };
}

const knowledgeChoiceModalStore = new Store();
export default knowledgeChoiceModalStore;
